"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2211],{

/***/ 72889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ UnionOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const UnionOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 65 64", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.67391 32C4.67391 16.6356 17.1356 4.17391 32.5 4.17391C47.8644 4.17391 60.3261 16.6356 60.3261 32C60.3261 47.3644 47.8644 59.8261 32.5 59.8261C17.1356 59.8261 4.67391 47.3644 4.67391 32ZM32.5 0C14.8304 0 0.5 14.3304 0.5 32C0.5 49.6696 14.8304 64 32.5 64C50.1696 64 64.5 49.6696 64.5 32C64.5 14.3304 50.1696 0 32.5 0ZM29.9897 31.987L18.3869 20.3842C18.0652 20.0511 17.8873 19.605 17.8913 19.142C17.8954 18.679 18.0811 18.2361 18.4085 17.9087C18.7359 17.5812 19.1788 17.3955 19.6418 17.3915C20.1048 17.3875 20.5509 17.5655 20.8839 17.8871L20.8926 17.8955L32.4868 29.4899L44.0896 17.8871C44.4227 17.5654 44.8688 17.3875 45.3318 17.3915C45.7948 17.3955 46.2377 17.5812 46.5652 17.9087C46.8926 18.2361 47.0783 18.679 47.0823 19.142C47.0863 19.605 46.9083 20.0511 46.5867 20.3841L46.5783 20.3928L34.9839 31.987L46.5744 43.5775C46.7408 43.7394 46.8736 43.9326 46.9653 44.146C47.0579 44.3614 47.1066 44.5931 47.1086 44.8276C47.1106 45.0621 47.066 45.2946 46.9772 45.5116C46.8884 45.7286 46.7573 45.9258 46.5915 46.0916C46.4256 46.2574 46.2285 46.3885 46.0115 46.4773C45.7944 46.5661 45.5619 46.6108 45.3274 46.6088C45.093 46.6067 44.8613 46.558 44.6458 46.4655C44.4324 46.3738 44.2393 46.241 44.0773 46.0746L32.4868 34.4841L20.884 46.0869C20.551 46.4086 20.1048 46.5865 19.6418 46.5825C19.1788 46.5784 18.7359 46.3927 18.4085 46.0653C18.0811 45.7379 17.8954 45.295 17.8913 44.832C17.8873 44.369 18.0653 43.9229 18.387 43.5899L18.3954 43.5812L29.9897 31.987Z",
          fill: "#DA4343"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 62211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PopupPromotion": function() { return /* binding */ PopupPromotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45838);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8081);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72889);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: -1000;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  z-index: 1060;\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




const Backdrop = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject());
const WrapperLazyImage = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].div((param)=>{
    let { width  } = param;
    return "\n  width: ".concat(width, ";\n  z-index: 2000;\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;}\n");
});
const IconClose = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject1());
const PopupPromotion = (param)=>{
    let { banner , isMobile =false  } = param;
    const sessionName = "promoBanner".concat(isMobile ? "_mobile" : "_desktop");
    const { 0: isShow , 1: setIsShow  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(()=>{
        if (typeof sessionStorage !== "undefined") return !sessionStorage.getItem(sessionName);
        return true;
    });
    const handleClose = ()=>{
        setIsShow(false);
        sessionStorage.setItem(sessionName, banner.image);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__/* .Overlay */ .a, {
        show: isShow,
        onEscPressed: handleClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Backdrop, {
                onClick: handleClose
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(WrapperLazyImage, {
                width: isMobile ? "90%" : "500px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconClose, {
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .UnionOutlined */ .o, {
                            size: 28,
                            color: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x, {
                        href: banner.targetPath,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .E, {
                            onClick: handleClose,
                            src: banner.image,
                            alt: banner.campaignName || banner.description || sessionName
                        })
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);